export var PortalModeType;
(function (PortalModeType) {
    PortalModeType[PortalModeType["Employee"] = 0] = "Employee";
    PortalModeType[PortalModeType["Manager"] = 1] = "Manager";
})(PortalModeType || (PortalModeType = {}));
